





























import AccountSettings from '@/mixins/accountSettings.mixin';
import DeviceWidthCheckerMixin from '@/mixins/deviceWidthChecker.mixin';
import { Component, Mixins } from 'vue-property-decorator';
import APP_CONST from '@/constants/AppConst';
import cartStore from '@/store/modules/checkout/cart/module';
import APP_UTILITIES from '@/utilities/commonFunctions';
import Spinner from '@/commoncomponents/spinner/Spinner.vue';
import { getInstance } from '@/auth';

@Component(
  {
    components: {
      Spinner
    }
  }
)
export default class CartLink extends Mixins(DeviceWidthCheckerMixin, AccountSettings) {
  public APP_ROUTES = APP_CONST.APP_ROUTES;
  commonEntryUnsubscribe: any;
  cartStore = cartStore;
  APP_CONST = APP_CONST;

  get cartItemCount(): number {
    return cartStore.cartItems.length;
  }

  created() {
    const { isAuthenticated } = getInstance();
    cartStore.initializeCartState(isAuthenticated);
  }
}

